export const convertResourceCategoryToPageSlug = (category: string): string => {
  return category
    .toLowerCase()
    .replace('& ', '')
    .replace("'", '')
    .split(' ')
    .join('-');
};
